import React from "react"
import Pulse from './Pulse'

const RectangleIcon = ({
  iconSize,
  icon,
  colors,
  selected = false,
  hovered = false,
  pulse = false,
  onMouseEnter = () => {},
  onMouseLeave = () => {}
}) => {
  return (
    <svg
      x={0}
      y={0}
      viewBox={`0 0 66 66`}
      width={iconSize}
      height={iconSize}
      style={{cursor: 'pointer'}}
      onMouseLeave={onMouseLeave}
      onMouseEnter={onMouseEnter}
    >
      <rect
        x={5}
        y={5}
        width={56}
        height={56}
        rx={12}
        ry={12}
        fill={selected ? colors.active.bgcolor : hovered ? colors.hover.bgcolor : colors.default.bgcolor}
        stroke={selected ? colors.active.bordercolor : hovered ? colors.hover.bordercolor : colors.default.bordercolor}
        strokeWidth="3" 
        filter={`drop-shadow( 1px 2px 1px rgba(0, 0, 0, .16))`}
      >
        {pulse && (
          <Pulse
            scale={'1 1; 1.1 1.1; 1 1'}
            translate={'0 0; -3.08 -3.08; 0 0'}
          />
        )}
      </rect>
      <svg x={21} y={21}>
        <image 
          href={icon} 
          filter={selected ? colors.active.svgColorFilter : colors.default.svgColorFilter} 
          width={24} 
          height={24}
        />
      </svg>
    </svg>
  )
}

export default RectangleIcon